import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppLayout } from "./components/layout/app-layout";

// Each screen-feature agent replaces the body of its own page.tsx later —
// lazy-loaded so one screen's bundle/code doesn't block the others.
const InboxPage = lazy(() => import("./pages/inbox/page"));
const LeadsAllPage = lazy(() => import("./pages/leads-all/page"));
const ConversationPage = lazy(() => import("./pages/conversation/page"));
const CampaignsPage = lazy(() => import("./pages/campaigns/page"));
const CampaignDetailPage = lazy(() => import("./pages/campaigns/detail/page"));

function PageFallback() {
  return <div>Loading…</div>;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route
            index
            element={
              <Suspense fallback={<PageFallback />}>
                <InboxPage />
              </Suspense>
            }
          />
          <Route
            path="all"
            element={
              <Suspense fallback={<PageFallback />}>
                <LeadsAllPage />
              </Suspense>
            }
          />
          <Route
            path="c/:id"
            element={
              <Suspense fallback={<PageFallback />}>
                <ConversationPage />
              </Suspense>
            }
          />
          <Route
            path="campaigns"
            element={
              <Suspense fallback={<PageFallback />}>
                <CampaignsPage />
              </Suspense>
            }
          />
          <Route
            path="campaigns/:id"
            element={
              <Suspense fallback={<PageFallback />}>
                <CampaignDetailPage />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
